import { Card, CardContent, Chip, CircularProgress, Grid, Paper } from "@material-ui/core";
import * as React from "react";
import {
  BooleanInput,
  Button,
  Create,
  RadioButtonGroupInput,
  SelectInput,
  TextInput,
  Toolbar,
  required,
  useNotify,
} from "react-admin";
import { ModuleTypeChoices } from "./Constant";
import TiptapRichTextInputField from "../../../Components/TiptapRichTextInput";
import CustomerSelect from "../../../Components/CustomerSelect/CustomerSelect";
import { ModuleType } from "../../../Enums/ModuleType";
import { GetPbhStepType, GetRbhStepType, StepType } from "../../../Enums/StepType";
import InfoIcon from "@material-ui/icons/Info";
import { Separator } from "../../../Components/Separator";
import { Form } from "react-final-form";
import { Add } from "@material-ui/icons";
import { MailManagementCreateModel } from "./MailManagementCreateModel";
import { useAppDataProvider } from "../../../dataprovider";
import { useHistory } from "react-router-dom";
import { useVerifyPermission } from "@airborne/react-admin";

const MailSchemaCreate = props => {
  useVerifyPermission("mailmanagements", "create");
  const dataProvider = useAppDataProvider();
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const [mailSchemas, setMailSchemas] = React.useState<any>([]);
  const [selectedSchema, setSelectedSchema] = React.useState<any>(StepType.PbhOrderCreated);
  const [schemaInfo, setSchemaInfo] = React.useState<any>({} as any);
  const [selectedModuleType, setSelectedModuleType] = React.useState<ModuleType>(ModuleType.Pbh);
  const [selectedText, setSelectedText] = React.useState<any>(
    GetPbhStepType.find(x => (x.Value = StepType.PbhOrderCreated))?.Description
  );
  const [selectedOwner, setSelectedOwner] = React.useState<any>({} as any);
  const notify = useNotify();

  //#region useEffect
  React.useEffect(() => {
    getMailSchemas();
  }, []);

  React.useEffect(() => {
    setSchemaInfos(mailSchemas);
  }, [selectedModuleType, selectedSchema]);
  //#endregion

  //#region funct
  const setSchemaInfos = schemas => {
    let schemaInfo = schemas?.find?.(x => x.stepType === selectedSchema);
    setSchemaInfo(schemaInfo);
  };

  const getMailSchemas = () => {
    dataProvider
      .getList("mailschemas", {
        pagination: { page: 1, perPage: 999 },
        sort: { field: "id", order: "ASC" },
        filter: {},
      })
      .then(result => {
        if (result?.data?.length > 0) {
          setMailSchemas(result?.data);
          setSchemaInfos(result?.data);
        } else {
          setMailSchemas([]);
        }
      });
  };

  const moduleTypeOnChange = (form, e) => {
    setSelectedModuleType(e);
    if (e === ModuleType.Pbh) {
      form.change("schema", StepType.PbhOrderCreated);
      setSelectedText(GetPbhStepType.find(x => (x.Value = StepType.PbhOrderCreated))?.Description);
      let defaultData = mailSchemas.find(x => x.stepType === StepType.PbhOrderCreated);
      form.change("subject", defaultData?.subject);
      form.change("body", defaultData?.body);
    } else {
      form.change("schema", StepType.OrderCreated);
      setSelectedText(GetRbhStepType.find(x => (x.Value = StepType.OrderCreated))?.Description);
      let defaultData = mailSchemas.find(x => x.stepType === StepType.OrderCreated);
      form.change("subject", defaultData?.subject);
      form.change("body", defaultData?.body);
    }
  };

  const getStepTypeDescription = (stepType: StepType) => {
    let selectedText = getStepTypes().find(x => x.Value === stepType)?.Description ?? null;
    setSelectedText(selectedText);
  };

  const schemaOnChange = e => {
    let val = e.target.value;
    getStepTypeDescription(val);
    setSelectedSchema(val);
  };

  const ownerOnChange = e => {
    setSelectedOwner({ id: e?.target?.value, name: e?.target?.name });
  };

  const handleSubmit = async e => {
    let mailManagementCreateModel: MailManagementCreateModel = new MailManagementCreateModel();
    mailManagementCreateModel.Body = e?.body;
    mailManagementCreateModel.Cc = e?.cc;
    mailManagementCreateModel.CustomerId = e?.ownerCode;
    mailManagementCreateModel.StepTypeEnum = e?.schema;
    mailManagementCreateModel.Subject = e?.subject;
    mailManagementCreateModel.To = e?.to;
    mailManagementCreateModel.IsMailFreeze = e?.isMailFreeze;
    mailManagementCreateModel.IsCustomer = true;

    setLoading(true);
    dataProvider
      .postMailManagement(mailManagementCreateModel)
      .then(result => {
        notify(`Record created`, "success", false, true);
        setLoading(false);
        history.push("/mailmanagements/" + result?.data?.id);
      })
      .catch(result => {
        setLoading(false);
      });
  };

  const getStepTypes = () => {
    if (selectedModuleType === ModuleType.Pbh) {
      return GetPbhStepType;
    } else {
      return GetRbhStepType;
    }
  };
  //#endregion

  return (
    <Create title={"Mail Management Create"} component="div" {...props}>
      <Form
        {...props}
        onSubmit={handleSubmit}
        render={({ form, handleSubmit }) => {
          return (
            <>
              <Paper style={{ color: "#c80c0f", fontWeight: 500 }}>
                <Card style={{ marginBottom: 5, marginTop: 15 }}>
                  <CardContent>
                    <Grid container spacing={2}>
                      <RadioButtonGroupInput
                        source="moduleType"
                        label="Module Type"
                        fullWidth
                        defaultValue={ModuleType.Pbh}
                        onChange={e => {
                          moduleTypeOnChange(form, e);
                        }}
                        choices={ModuleTypeChoices}
                        validate={required()}
                        variant="outlined"
                      />
                      <Grid item xs={12} sm={6} md={6} lg={4}>
                        <SelectInput
                          label="Schema"
                          source="schema"
                          choices={getStepTypes()}
                          optionText="Text"
                          optionValue="Value"
                          defaultValue={StepType.PbhOrderCreated}
                          onChange={schemaOnChange}
                          fullWidth
                          variant="outlined"
                          validate={required()}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={4}>
                        {selectedText && (
                          <Chip
                            size="medium"
                            style={{ color: "#767676" }}
                            variant="outlined"
                            label={selectedText}
                            icon={<InfoIcon />}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Paper>
              <Separator />
              <Card>
                <form>
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6} md={6} lg={4}>
                        <CustomerSelect initialValue={selectedOwner?.id} onChange={ownerOnChange} />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={4}>
                        <BooleanInput defaultValue={false} source="isMailFreeze" label={"Deactivate"} />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={4} />
                      <Grid item xs={12} sm={6} md={6} lg={4}>
                        <TextInput validate={required()} source="to" label="TO" fullWidth multiline />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={4}>
                        <TextInput source="cc" label="CC" fullWidth multiline />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={4} />
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <TextInput
                          initialValue={schemaInfo?.subject ?? ""}
                          source="subject"
                          label="Subject"
                          validate={required()}
                          fullWidth
                          multiline
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <TiptapRichTextInputField
                          key={schemaInfo?.id}
                          initialValue={schemaInfo?.body ?? ""}
                          source="body"
                          validate={[required()]}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                  <Toolbar {...props} placeholder="">
                    <Button
                      label={loading ? "Mail is creating!" : "Create"}
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      style={{ margin: "8px" }}
                      onClick={() => handleSubmit()}
                    >
                      {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                    </Button>
                  </Toolbar>
                </form>
              </Card>
            </>
          );
        }}
      />
    </Create>
  );
};

export default MailSchemaCreate;
